import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AdminPage from "@/pages/Admin";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Products } from "@/components/Products";
import { About } from "@/components/About";
import { HowItWorks } from "@/components/HowItWorks";
import { VisitUs } from "@/components/VisitUs";
import { Reviews } from "@/components/Reviews";
import { ContactCTA } from "@/components/ContactCTA";
import { Footer } from "@/components/Footer";

function Landing() {
  return (
    <div id="top" className="bg-bone text-ink antialiased min-h-screen font-body">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Products />
        <About />
        <HowItWorks />
        <VisitUs />
        <Reviews />
        <ContactCTA />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
